const CANADIAN_TIMEZONES = [
  'America/Toronto', 'America/Montreal', 'America/Vancouver',
  'America/Edmonton', 'America/Winnipeg', 'America/Halifax',
  'America/St_Johns', 'America/Regina', 'America/Yellowknife',
  'America/Whitehorse', 'America/Iqaluit', 'America/Moncton',
  'America/Thunder_Bay', 'America/Nipigon', 'America/Rainy_River',
  'America/Rankin_Inlet', 'America/Resolute', 'America/Pangnirtung',
  'America/Atikokan', 'America/Glace_Bay', 'America/Goose_Bay',
  'America/Blanc-Sablon', 'America/Cambridge_Bay', 'America/Dawson',
  'America/Dawson_Creek', 'America/Fort_Nelson', 'America/Inuvik',
  'America/Creston', 'America/Swift_Current',
];

export const detectRegion = () => {
  // Allow override for testing/demo
  const override = localStorage.getItem('regionOverride');
  if (override && ['CA', 'US', 'EU'].includes(override)) return override;
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (CANADIAN_TIMEZONES.includes(tz)) return 'CA';
    if (tz.startsWith('America/')) return 'US';
    if (tz.startsWith('Europe/') || tz.startsWith('Africa/')) return 'EU';
  } catch {}
  return 'CA';
};

// Flag images per region for the intro animation
const CANADA_FLAG = 'https://customer-assets.emergentagent.com/job_dashboard-114/artifacts/s0k80gbv_image.png';
const QUEBEC_FLAG = 'https://customer-assets.emergentagent.com/job_dashboard-114/artifacts/5enshwlr_image.png';
const US_FLAG = 'https://flagcdn.com/w160/us.png';
const UK_FLAG = 'https://flagcdn.com/w160/gb.png';
const FR_FLAG = 'https://flagcdn.com/w160/fr.png';

export const getIntroFlags = (region) => {
  switch (region) {
    case 'US': return { en: { src: US_FLAG, alt: 'US Flag' }, fr: { src: FR_FLAG, alt: 'French Flag' } };
    case 'EU': return { en: { src: UK_FLAG, alt: 'UK Flag' }, fr: { src: FR_FLAG, alt: 'French Flag' } };
    default:   return { en: { src: CANADA_FLAG, alt: 'Canadian Flag' }, fr: { src: QUEBEC_FLAG, alt: 'Quebec Flag' } };
  }
};

// Flag emoji pairs for the navbar split-flag toggle
export const getSplitFlagPair = (region) => {
  switch (region) {
    case 'US': return { left: US_FLAG, right: FR_FLAG };
    case 'EU': return { left: UK_FLAG, right: FR_FLAG };
    default:   return { left: 'https://flagcdn.com/w80/ca.png', right: FR_FLAG };
  }
};
